<template>
    <import-question @import="swap" noActivator ref="importer">
        <template v-if="swapQuestion" #information>
            Ganti pertanyaan: {{ swapQuestion.question }}
        </template>
    </import-question>
</template>

<script>
import ImportQuestion from './ImportQuestion.vue'

export default {
    components: {
        ImportQuestion,
    },

    data: () => ({
        questions: null,
        swapQuestion: null
    }),

    methods: {
        swap(newQuestions) {
            const idx = this.questions.findIndex(question => question.id == this.swapQuestion.id)

            this.questions.splice(idx, 1, ...newQuestions)

            this.$emit('update:questions', this.questions)
        },

        show(questions, swapQuestion) {
            this.questions = questions
            this.swapQuestion = swapQuestion

            this.$refs.importer.show()
        }
    }
}
</script>
